module.exports = __webpack_public_path__ + "static/img/h5-bg2.f3da71f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/h5-bg2.jpg
// module id = LpwM
// module chunks = 0